module.exports = __webpack_public_path__ + "images/tips/guide-1@2x.eab001f563b4e3d8a5d1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/tips/guide-1@2x.png
// module id = toyc
// module chunks = 12